import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  Component,
  Input,
  SimpleChanges,
  ElementRef,
  Renderer2,
  OnChanges,
  AfterViewInit,
  TemplateRef,
} from '@angular/core';
import { SlideStates, SlideConfig, CSSAnimationFunctions, CSSDisplay } from '../../models/slide';

////////////////////////////////////
// CONFIGURACION POR DEFECTO
////////////////////////////////////
const slideDefConfig: SlideConfig = {
  // configuracion de la animacion
  animationConfig: {
    time: 0.25,
    function: CSSAnimationFunctions.Ease_in_out,
  },
  // render del contenido (cuando - SlideState.Up)
  contentDisplay: CSSDisplay.None,
};

const ANIMATE_REPLACE = '{{time}}s {{function}}';
////////////////////////////////////
// ANIMACION - slideAnimation
////////////////////////////////////
export const slideAnimation = trigger('slide', [
  state(
    SlideStates.CLOSE,
    style({
      height: '0px',
    }),
    { params: { renderContent: slideDefConfig.contentDisplay } }
  ),
  state(
    SlideStates.OPEN,
    style({
      height: '*',
    })
  ),
  state(
    SlideStates.LATERAL_CLOSE,
    style({
      width: '0',
    }),
    { params: { renderContent: slideDefConfig.contentDisplay } }
  ),
  state(
    SlideStates.LATERAL_OPEN,
    style({
      width: '*',
    })
  ),
  transition(SlideStates.CLOSE + ' => ' + SlideStates.OPEN, animate(ANIMATE_REPLACE), {
    params: { time: slideDefConfig.animationConfig.time, function: slideDefConfig.animationConfig.function },
  }),
  transition(SlideStates.OPEN + ' => ' + SlideStates.CLOSE, animate(ANIMATE_REPLACE), {
    params: { time: slideDefConfig.animationConfig.time, function: slideDefConfig.animationConfig.function },
  }),
  transition(SlideStates.LATERAL_CLOSE + ' => ' + SlideStates.LATERAL_OPEN, animate(ANIMATE_REPLACE), {
    params: { time: slideDefConfig.animationConfig.time, function: slideDefConfig.animationConfig.function },
  }),
  transition(SlideStates.LATERAL_OPEN + ' => ' + SlideStates.LATERAL_CLOSE, animate(ANIMATE_REPLACE), {
    params: { time: slideDefConfig.animationConfig.time, function: slideDefConfig.animationConfig.function },
  }),
]);

////////////////////////////////////
// COMPONENTE
////////////////////////////////////
/**
 */
@Component({
  standalone: false,
  selector: 'app-slide',
  templateUrl: './slide.component.html',
  styleUrls: ['./slide.component.scss'],
  animations: [slideAnimation],
})
export class SlideComponent implements OnChanges, AfterViewInit {
  private refTimeout: any;

  /**
   * Maneja el estado principal del slide (abierto/cerrado)
   *
   */
  @Input() slideState: SlideStates = SlideStates.CLOSE;
  /**
   * Configuración del componente, por defecto slideDefConfig
   *
   */
  @Input() slideConfig: SlideConfig = slideDefConfig;
  /**
   * Espacio reservado para el contenido oculto. Admite "px, css calc(), %, number, vw"
   *
   */
  @Input() reservedSpace = '0';

  public isOpen = this.slideState === SlideStates.CLOSE ? false : true;

  @Input() template: any = null;
  @Input() templateData: any = {};

  /**
   * Creates an instance of SlideComponent.
   */
  constructor(
    private readonly host: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    this.setReservedSpace(this.reservedSpace, this.host, this.renderer);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.controlProjectionDom(changes, this.slideConfig.animationConfig.time);
  }

  /**
   * Controla la proyección del contenido en base a los cambios en slideState
   *
   */
  controlProjectionDom(changes: SimpleChanges, delay: number): void {
    if (changes['slideState']) {
      if (
        changes['slideState'].currentValue === SlideStates.OPEN ||
        changes['slideState'].currentValue === SlideStates.LATERAL_OPEN
      ) {
        this.isOpen = true;
        if (this.refTimeout) {
          clearTimeout(this.refTimeout);
        }
      } else if (
        changes['slideState'].currentValue === SlideStates.CLOSE ||
        changes['slideState'].currentValue === SlideStates.LATERAL_CLOSE
      ) {
        if (this.refTimeout) {
          clearTimeout(this.refTimeout);
        }
        this.refTimeout = setTimeout(() => {
          this.isOpen = false;
        }, delay * 1000); // s to ms
      }
    }
  }

  /**
   * Aplica un mínimo de altura sobre el ElementRef
   *
   */
  setReservedSpace(height: string, element: ElementRef, render: Renderer2) {
    if (height !== '0') {
      render.setStyle(element.nativeElement, 'min-height', height);
    }
  }
}
